import { memo, useCallback, type FC } from "react";
import { Switch, Tooltip, message } from "antd";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

interface AiGeneratorCardProps {
  checked: boolean;
  disabled: boolean;
  onChange: (_checked: boolean) => void;
}

const AiGeneratorCard: FC<AiGeneratorCardProps> = ({ checked, disabled, onChange }) => {
  const { t } = useTranslation();
  const title = t("campaignFlow.common.aiGeneratorTitle");
  const disabledMessage = t("campaignFlow.createCampaignNew.aiDisableMessage");

  const showDisabledMessage = useCallback(() => {
    message.info(disabledMessage);
  }, [disabledMessage]);

  return (
    <section className={`campaign-ai-card ${checked ? "campaign-ai-card--active" : ""}`}>
      <div className="campaign-ai-card__header">
        <Sparkles className="campaign-ai-card__icon" aria-hidden />
        <div className="campaign-ai-card__heading">
          <h3 className="campaign-ai-card__title">{title}</h3>
          <span className="campaign-ai-card__powered-by">
            {t("campaignFlow.createCampaignNew.aiPoweredBy")}
          </span>
        </div>
        <Tooltip title={disabled ? disabledMessage : ""}>
          <span
            className="campaign-ai-card__toggle"
            onClick={disabled ? showDisabledMessage : undefined}
          >
            <span className="campaign-ai-card__status" aria-hidden>
              {checked
                ? t("campaignFlow.createCampaignNew.aiOn")
                : t("campaignFlow.createCampaignNew.aiOff")}
            </span>
            <Switch
              size="small"
              checked={checked}
              disabled={disabled}
              onChange={onChange}
              aria-label={title}
              className="campaign-ai-card__switch"
            />
          </span>
        </Tooltip>
      </div>
      <p className="campaign-ai-card__description">
        {t("campaignFlow.createCampaignNew.aiGeneratorSubtext")}
      </p>
    </section>
  );
};

export default memo(AiGeneratorCard);
